import { CategoryGroupIds } from './../../../../modules/shared/constants/category-groupid.constants';
import { TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainService } from 'src/app/app-main.service';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { AppMainComponent } from '../../../../app.main.component';
import { Status } from '../../constants/constants';
import { CaseService } from '../case.service';
import { Answer } from '../../constants/constants';

export interface FieldDetails {
  configurationId: number,
  fieldType: string,
  fieldId: number,
  isDefault: boolean
}
@Component({
  selector: 'app-case-fields',
  templateUrl: './fields.component.html',
  styleUrls: ['./fields.component.scss'],
  providers: [ConfirmationService]
})
export class CaseFieldsComponent implements OnInit, OnChanges {

  @Input() caseFieldConfig = null;
  @Input() caseSources = [];
  @Input() casePriorities = [];
  @Input() addNewField: any;
  @Input() configId: number;
  @Input() allCaseChannels;

  @Output() reLoadConfigurations = new EventEmitter();

  sourceList = [];
  prioritiesList = [];
  allCasefield = [];

  displayAddCaseData:boolean = false;
  addEditCaseHeader:string ='';
  invalidData:boolean = true;
  isEditFieldData:boolean = true;
  caseDataTemp = {
    "organizationId": this.app.user.organizationId,
    "name": " ",
    "description": "",
    "configJSONSchema": "",
    "configJSONValue": [],
    "objectId": 169,
    "levelId": 2,
    "levelRecordId": 0,
    "categoryId": 0,
    "statusId": 1,
    "typeId": 98,
    "id": 0,
    "createdSource": "Web",
    "updatedSource": this.app.userIP,
    "createdBy": this.app.user.userId,
    "updatedBy": 0,
    "createdDate": new Date(),
    "updatedDate": new Date(),
    "isActive": true,
    "isDefault": true
  }
  caseDataTypes = [
    { id: 1, name: "Source", code: "source" },
    { id: 2, name: "Category", code: "category" },
    { id: 3, name: "Priority", code: "priority" },
    { id: 4, name: "Resolved Reason", code: "resolved" },
    { id: 5, name: "Unresolved Reason", code: "unResolved" }

  ]
  selectedCaseDataType;
  caseTypeId = 0;
  ErrorMessageName = "";
  isDisabledFieldData = false;
  formSubmitted = false;
  noDataFieldData ='';

  casesCategories = [];
  casesAllCategories = [];
  selectedCategory;
  subCates = [];

  answertypeConstants = Answer;
  configurationId : number;
  moduleName : string = 'case';

  // Resolved Unresolved

  resolvedReasons: Array<any>;
  unResolvedReasons: Array<any>;

  constructor(
    private fb: FormBuilder, private app: AppMainComponent, private messageService: MessageService,
    private confirmationService: ConfirmationService, private caseConfigService: CaseService,
    private service: ConfigurationService,
    private appMainService: AppMainService,
    private titlecasePipe: TitleCasePipe) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.caseSources && changes.caseSources.currentValue){
      this.sourceList = changes.caseSources.currentValue;
    }
    if(changes.casePriorities && changes.casePriorities.currentValue){
      this.prioritiesList = changes.casePriorities.currentValue;
    }

    if(changes.caseFieldConfig && changes.caseFieldConfig.currentValue){
      this.allCasefield = this.caseFieldConfig != null ? JSON.parse(this.caseFieldConfig.configurationDetails && this.caseFieldConfig.configurationDetails[0].configJSONValue) : [];
    }
    if(changes.addNewField && changes.addNewField.currentValue){
      const newRecordObj = changes.addNewField.currentValue;
      if(newRecordObj.name =='Field'){
        this.showNewField();
      }
    }

    if(changes.configId && changes.configId.currentValue){
      this.configurationId = changes.configId.currentValue;
    }
  }

  ngOnInit(): void {
    this.getCaseCategories();
    this.getResolvedReason();
    this.getUnresolvedReason();
  }

  showNewField(){
    this.displayAddCaseData = true;
    this.addEditCaseHeader = "Add Field Data";
    this.invalidData = false;
    this.isEditFieldData = false;

    this.caseDataTemp = {
      "id": 0,
      "createdSource": this.app.user.userIP,
      "updatedSource": this.app.user.userIP,
      "createdBy": this.app.user.userId,
      "updatedBy": this.app.user.organizationId,
      "createdDate": new Date(),
      "updatedDate": new Date(),
      "organizationId": this.app.user.organizationId,
      "name": "",
      "description": "",
      "configJSONSchema": "",
      "configJSONValue": [],
      "objectId": 8,
      "levelId": 0,
      "levelRecordId": 0,
      "categoryId": 0,
      "statusId": 1,
      "typeId": 98,
      "isActive": true,
      "isDefault": false
    }
  }

  onValidateName(Data) {
    if (Data.target.value.trim() == "" || Data.target.value.trim() == undefined) {
      this.ErrorMessageName = 'Name Is Required';
      this.isDisabledFieldData = true;
    }
    else {
      // ////console.log(this.caseDataTypes[this.caseTypeId].name);
      this.ErrorMessageName = '';
      if ((this.caseDataTemp.name.trim() != "" || this.caseDataTemp.name != "") && this.selectedCaseDataType != undefined)// && this.caseDataTypes[this.caseTypeId].name !='Select Field Type') {
      {
        this.ErrorMessageName = '';
        this.isDisabledFieldData = false;
      }
    }
  }

  async addEditCaseFieldData() {
    this.invalidData = false;
    if (this.checkValidationForCasesFieldData()) {
      this.formSubmitted = true;
    }
    if (this.caseDataTemp?.name == ""){
      this.isDisabledFieldData = true;
      return;
    }
    if (this.isDisabledFieldData){
      this.formSubmitted = false;
      return;
    }
    else {
      let duplicateRecord;
      // if(this.selectedCaseDataType.name =='Category'){
      //   if (this.caseDataTemp.id) {
      //     duplicateRecord = this.casesAllCategories != null ? this.casesAllCategories.find(obj => obj.name.toLowerCase().trim() == this.caseDataTemp.name.toLowerCase().trim() && obj.id !== this.caseDataTemp.id) : false;
      //   } else {
      //     duplicateRecord = this.casesAllCategories != null ? this.casesAllCategories.find(obj => obj.name.toLowerCase().trim() == this.caseDataTemp.name.toLowerCase().trim()) : false;
      //   }
      // } else if(this.selectedCaseDataType.name !=='Category'){
      //   if (this.caseDataTemp.id) {
      //     duplicateRecord = this.allCasefield != null ? this.allCasefield.find(obj => obj.name.toLowerCase().trim() == this.caseDataTemp.name.toLowerCase().trim() && obj.fieldsType == this.selectedCaseDataType.name && obj.id !== this.caseDataTemp.id) : false;
      //   } else {
      //     duplicateRecord = this.allCasefield != null ? this.allCasefield.find(obj => obj.name.toLowerCase().trim() == this.caseDataTemp.name.toLowerCase().trim() && obj.fieldsType == this.selectedCaseDataType.name) : false;
      //   }
      // }

      // if (duplicateRecord) {
      //   this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Name is already exist...' });
      // }
      // else {
        // categories have different api so its updated managed differently
        if(this.selectedCaseDataType.name =='Category'){
          this.addUpdateCaseCategory(this.caseDataTemp);
        }
        else if (this.selectedCaseDataType.name == "Resolved Reason") {
          this.addUpdateResolvedReason(this.caseDataTemp);
        }
        else if (this.selectedCaseDataType.name == "Unresolved Reason") {
          this.addUpdateUnresolvedReason(this.caseDataTemp);
        }
        else{
          this.formSubmitted = false;
          this.appMainService.isShowSpinner('CaseFieldData');
          this.caseDataTemp.createdSource = this.app.userIP;
          this.caseDataTemp.createdBy = this.app.user.organizationId;
          this.caseDataTemp.statusId = 1;
          this.caseDataTemp.createdDate = new Date();

          var arrayconfigJSONValue = [];
          let i = 1;
          if (this.caseFieldConfig != null && this.allCasefield != null) {
            var configJSONValue = "";
            for (let l of this.allCasefield) {
              var obj = {};
              if (l.id != this.caseDataTemp.id) {
                obj = {
                  id: i,
                  fieldsType: l.fieldsType,
                  name: l.name,
                  description: l.description,
                  isActive: l.isActive,
                  isDefault: l.isDefault,
                  subCategory: l.subCategory,
                  createdBy: l.createdBy,
                  createdDate: l.createdDate,
                }
                arrayconfigJSONValue.push(obj);
              }
              else {
                obj = {
                  id: i,
                  fieldsType: this.caseDataTypes[this.caseTypeId - 1].name,
                  name: this.caseDataTemp.name,
                  description: this.caseDataTemp.description,
                  isActive: this.caseDataTemp.isActive,
                  isDefault: l.isDefault,
                  subCategory: l.subCategory,
                  createdBy: l.createdBy,
                  createdDate: l.createdDate,
                }
                arrayconfigJSONValue.push(obj);
              }
              i = i + 1;
            }
          }
          if (!this.isEditFieldData) {
            var newObj = {
              id: i,
              fieldsType: this.selectedCaseDataType.name,
              name: this.caseDataTemp.name,
              description: this.caseDataTemp.description,
              isActive: this.caseDataTemp.isActive,
              isDefault: this.caseDataTemp.isDefault,
              subCategory: [],
              createdBy: this.caseDataTemp.createdBy,
              createdDate: new Date().toISOString()
            }
            arrayconfigJSONValue.push(newObj);
          }
          var configJSONValue = JSON.stringify(arrayconfigJSONValue);

          var FieldData = {
            "id": this.caseFieldConfig != undefined ? this.caseFieldConfig.id : 0,
            "createdSource": this.app.user.userIP,
            "updatedSource": this.app.user.userIP,
            "createdBy": this.app.user.userId,
            "updatedBy": this.app.user.userId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.app.user.organizationId,
            "name": 'Field Data Cases Configuration',
            "description": 'Field Data Cases Configuration',
            "configJSONSchema": "string",
            "configJSONValue": configJSONValue,
            "objectId": 8, // objectid for cases configuration in DB
            "levelId": 2, // For organzation level use 2
            "levelRecordId": this.app.user.organizationId,
            "categoryId": 6, // CategoryId for case data field in DB
            "statusId": 1, // For active user , use 1
            "typeId": 98 // typeid for case data field in DB
          }
          if (this.addEditCaseHeader == "Add Field Data" && FieldData.id == 0) {

            this.service.addConfiguration(FieldData).then(stages => {
              this.displayAddCaseData = false;
                this.appMainService.isHideSpinner('CaseFieldData');
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Field Data Added successfully...' });
                this.reLoadConfigurations.emit({});

            }).catch((errResp) => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving  data...' });
            }).finally(() => {
              this.appMainService.isHideSpinner('CaseFieldData');
              this.noDataFieldData = 'No Data Available.';
            });
          } else if (FieldData.id > 0) {
            // this.appMainService.isShowSpinner('CaseFieldData');
            this.service.updateConfiguration(FieldData).then(stages => {
              this.displayAddCaseData = false;
              this.appMainService.isHideSpinner('CaseFieldData');

              if (!this.isEditFieldData) {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Field Data Added successfully...' });
              } else {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Field Data Updated successfully...' });
              }
              this.reLoadConfigurations.emit({});
            }).catch((errResp) => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving  data...' });
            }).finally(() => {
              //this.appMainService.isHideSpinner('CaseFieldData');
              this.noDataFieldData = 'No Data Available.';
            });
          }
        }
      //}
    }
  }

  checkValidationForCasesFieldData() {
    let showError = false;
    if ((this.addEditCaseHeader == "Add Field Data" && !this.selectedCaseDataType) || !this.caseDataTemp.name) {
      showError = true;
    }
    return showError;
  }

  addUpdateCaseCategory(caseDataTemp){

      const categoryData = {
        "id": caseDataTemp.id ? caseDataTemp.id: 0,
        "createdSource": caseDataTemp.createdSource ? caseDataTemp.createdSource: this.app.user.userIP,
        "updatedSource": caseDataTemp.id ? this.app.user.userIP : null,
        "createdBy": caseDataTemp.createdBy ? caseDataTemp.createdBy : this.app.user.userId,
        "updatedBy": caseDataTemp.id ? this.app.user.userId : null,
        "createdDate": caseDataTemp.createdDate ? caseDataTemp.createdDate : new Date(),
        "updatedDate": caseDataTemp.id? new Date(): null,
        "name": caseDataTemp.name,
        "description":  caseDataTemp.description,
        "parentCategoryId": caseDataTemp.parentCategoryId ? caseDataTemp.parentCategoryId: 0,
        "statusId": caseDataTemp?.isActive == true ? 1 : 2,
        "isDefault": caseDataTemp.isDefault ? caseDataTemp.isDefault : false,
        "groupId": CategoryGroupIds.CaseCategoryTicketAPI,
        "typeId": 1,
        "isValid": true,
        "validFromDate": null,
        "validToDate": null,
        "childCategory": null,
        "organizationId": this.app.user.organizationId
      }
      if(categoryData.id > 0){
        this.service.updateCaseCategory(categoryData).subscribe(
          resp => {
            this.displayAddCaseData = false;
            this.getCaseCategories();
            this.appMainService.isHideSpinner('CaseFieldData');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Case Category updated successfully...' });
            this.closeAddEditCaseFieldData();
          },
          err =>{
            //this.displayAddCaseData = false;
            this.appMainService.isHideSpinner('CaseFieldData');
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
          }
        )
      } else{
        this.service.addCaseCategory(categoryData).subscribe(
          resp => {
            this.displayAddCaseData = false;
            this.getCaseCategories();
            this.appMainService.isHideSpinner('CaseFieldData');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Case Caetgory Added successfully...' });
            this.closeAddEditCaseFieldData();
          },
          err =>{
            //this.displayAddCaseData = false;
            this.appMainService.isHideSpinner('CaseFieldData');
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
          }
        )
      }

  }

  getCaseCategories(){
    this.caseConfigService.getCaseCategories().subscribe(cates => {
      this.casesAllCategories = cates;
    });
  }

  delCaseSource(c, type) {
    const dataType = type? type : 'Source'
    this.confirmationService.confirm({
      message: `Do you want to delete this Case ${dataType}?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.deleteCaseFieldData(c.id);
      },
      reject: () => {
      }
    });
  }

  deleteCaseFieldData(id: any) {
    this.appMainService.isShowSpinner('DeleteFieldData');
    if (this.caseFieldConfig != null && this.allCasefield != null) {
      this.allCasefield = this.allCasefield.filter(e => e.id != id);
    }
    var arrayconfigJSONValue = [];
    var configJSONValue = "";
    let i = 1;
    for (let l of this.allCasefield) {
      var obj = {
        id: i,
        fieldsType: l.fieldsType,
        name: l.name,
        description: l.description,
        isActive: l.isActive,
        isDefault: l.isDefault,
        createdBy: l.createdBy,
        createdDate: l.createdDate,
      }
      arrayconfigJSONValue.push(obj);
      i = i + 1;
    }
    configJSONValue = JSON.stringify(arrayconfigJSONValue);
    var FieldData = {
      "id": this.caseFieldConfig != undefined ? this.caseFieldConfig.id : 0,
      "createdSource": this.app.user.userIP,
      "updatedSource": this.app.user.userIP,
      "createdBy": this.app.user.userId,
      "updatedBy": this.app.user.userId,
      "createdDate": new Date().toISOString(),
      "updatedDate": new Date().toISOString(),
      "organizationId": this.app.user.organizationId,
      "name": 'Field Data Cases Configuration',
      "description": 'Field Data Cases Configuration',
      "configJSONSchema": "string",
      "configJSONValue": configJSONValue,
      "objectId": 8, // objectId for cases configuration
      "levelId": 2, // For orgainzation level , use 2
      "levelRecordId": this.app.user.organizationId,
      "categoryId": 6, // categoryId for case data field
      "statusId": 1, // for active status
      "typeId": 98 // typeId for case data field configuration
    }

    this.service.updateConfiguration(FieldData).then(
      fieldData => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Field Data Deleted successfully...' });
        this.appMainService.isHideSpinner('DeleteFieldData');
        this.reLoadConfigurations.emit({});
      })
      .catch(err=>{
        this.messageService.add({ severity: 'error', summary: 'Error', detail:err.error.Message });
        this.appMainService.isHideSpinner('DeleteFieldData');
      });
  }

  onShowEditCategory($event){
    const c = $event.data;
    const s = $event.caseDataType;
    this.showEditCaseData(c, s)
  }

  showEditCaseData(c, s) {
    this.invalidData = false;
    this.caseDataTemp = JSON.parse(JSON.stringify(c));
    this.caseTypeId = s.id;
    this.selectedCaseDataType = s;
    this.addEditCaseHeader = "Edit Field Data";
    this.displayAddCaseData = true;
    this.isEditFieldData = true;
    this.isDisabledFieldData = false;
  }

  makeIsDefault(data : any): void {
    if (data){
      const fieldData : FieldDetails = {
        configurationId: this.configurationId,
        fieldType: data?.fieldsType,
        fieldId: data?.id,
        isDefault: true
      }
      this.appMainService.isShowSpinner('isDefaultField');
      this.caseConfigService.updateIsDefaultField(fieldData).then((response) => {
        //console.log(response);
        this.appMainService.isHideSpinner('isDefaultField');
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Field Data Updated successfully...' });
        this.reLoadConfigurations.emit({});

      }).catch((error) => {
        this.appMainService.isHideSpinner('isDefaultField');
        this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: error.error?.Message == null
                    ? "Error Occured, try again later"
                    : error.error?.Message,
        });
        this.reLoadConfigurations.emit({});

      })
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail:'Data not loaded, try again later' });
    }
  }

  closeAddEditCaseFieldData(): void {
    this.displayAddCaseData = false;
    this.formSubmitted = false;
    this.isDisabledFieldData = false;
    this.invalidData = false;
  }

  getResolvedReason(): void {
    this.appMainService.isShowSpinner('getResolvedReasons');

    this.caseConfigService.getAllResolvedReason().then((response) => {
      if (response != null){
        this.resolvedReasons = response;
        this.appMainService.isHideSpinner('getResolvedReasons');
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail:'Resolved reasons are not loaded' });
        this.appMainService.isHideSpinner('getResolvedReasons');
      }
    },
    (error) => {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: error.error?.Message == null
                ? "Error Occured, try again later"
                : error.error?.Message,
      });
    this.appMainService.isHideSpinner('getResolvedReasons');
    });
  }

  getUnresolvedReason(): void {
    this.appMainService.isShowSpinner('getUnresolvedReasons');

    this.caseConfigService.getAllUnresolvedReason().then((response) => {
      if (response != null){
        this.unResolvedReasons = response;
        this.appMainService.isHideSpinner('getUnresolvedReasons');
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail:'Unresolved reasons are not loaded' });
      this.appMainService.isHideSpinner('getUnresolvedReasons');
      }
    },
    (error) => {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: error.error?.Message == null
                ? "Error Occured, try again later"
                : error.error?.Message,
      });
    this.appMainService.isHideSpinner('getUnresolvedReasons');
    });
  }

  addUpdateResolvedReason(data: any): void {
    const resolvedData = {
      id: data.id ? data.id: 0,
      name: data?.name,
      description: data?.description,
      isActive: data?.isActive
    }
    this.appMainService.isShowSpinner('addUpdateResolvedReasons');
    if (resolvedData.id > 0){
      // Update
      this.caseConfigService.addUpdateResolvedReason(resolvedData).then((response) =>  {
          this.displayAddCaseData = false;
          this.getResolvedReason();
          this.appMainService.isHideSpinner('addUpdateResolvedReasons');
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Resolved reason updated successfully...' });
      },
      (error) => {
        this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: error.error?.Message == null
                ? "Error Occured, try again later"
                : error.error?.Message,
        });
        this.appMainService.isHideSpinner('addUpdateResolvedReasons');
      });
    }
    else {
      // Add
      this.caseConfigService.addUpdateResolvedReason(resolvedData).then((response) =>  {
        this.displayAddCaseData = false;
        this.getResolvedReason();
        this.appMainService.isHideSpinner('addUpdateResolvedReasons');
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Resolved reason added successfully...' });
      },
      (error) => {
        this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: error.error?.Message == null
                ? "Error Occured, try again later"
                : error.error?.Message,
        });
        this.appMainService.isHideSpinner('addUpdateResolvedReasons');
      });
    }

  }

  addUpdateUnresolvedReason(data: any): void {
    const unResolvedData = {
      id: data.id ? data.id: 0,
      name: data?.name,
      description: data?.description,
      isActive: data?.isActive
    }
    this.appMainService.isShowSpinner('addUpdateUnResolvedReasons');
    if (unResolvedData.id > 0){
      // Update
      this.caseConfigService.addUpdateUnresolvedReason(unResolvedData).then((response) =>  {
          this.displayAddCaseData = false;
          this.getUnresolvedReason();
          this.appMainService.isHideSpinner('addUpdateUnResolvedReasons');
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'UnResolved reason updated successfully...' });
      },
      (error) => {
        this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: error.error?.Message == null
                ? "Error Occured, try again later"
                : error.error?.Message,
        });
        this.appMainService.isHideSpinner('addUpdateUnResolvedReasons');
      });
    }
    else {
      // Add
      this.caseConfigService.addUpdateUnresolvedReason(unResolvedData).then((response) =>  {
        this.displayAddCaseData = false;
        this.getUnresolvedReason();
        this.appMainService.isHideSpinner('addUpdateUnResolvedReasons');
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'UnResolved reason added successfully...' });
      },
      (error) => {
        this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: error.error?.Message == null
                ? "Error Occured, try again later"
                : error.error?.Message,
        });
        this.appMainService.isHideSpinner('addUpdateUnResolvedReasons');
      });
    }
  }

  makeIsDefaultResolvedUnresolved(data, caseDataType): void{
    // Id 4 for resolved reason
    const defaultData = {
      reasonId: data?.id,
      isDefault: true
    }
    this.appMainService.isShowSpinner('isDefaultResolvedUnresolved');
    if (caseDataType?.id == 4){
      this.caseConfigService.changeIsDefaultResolvedReason(defaultData).then((response) => {
        this.getResolvedReason();
        this.appMainService.isHideSpinner('isDefaultResolvedUnresolved');
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Resolved data updated successfully...' });
      },
      (error) => {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: error.error?.Message == null
                  ? "Error Occured, try again later"
                  : error.error?.Message,
          });
          this.appMainService.isHideSpinner('isDefaultResolvedUnresolved');
      });
    }
    else {
      this.caseConfigService.changeIsDefaultUnresolvedReason(defaultData).then((response) => {
        this.getUnresolvedReason();
        this.appMainService.isHideSpinner('isDefaultResolvedUnresolved');
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Unresolved data updated successfully...' });
      },
      (error) => {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: error.error?.Message == null
                  ? "Error Occured, try again later"
                  : error.error?.Message,
          });
          this.appMainService.isHideSpinner('isDefaultResolvedUnresolved');
      });
    }
  }

  deleteResolveUnresolved(data, caseDataType): void {
    //const dataType = caseDataType? type : 'Source'
    this.confirmationService.confirm({
      message: `Do you want to delete this ${caseDataType?.name}?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.deleteActionForResolveUnresolved(data, caseDataType);
      },
      reject: () => {
      }
    });

  }

  deleteActionForResolveUnresolved(data, caseDataType): void {
    this.appMainService.isShowSpinner('isDeleteResolvedUnresolved');
    if (caseDataType?.id == 4){
      this.caseConfigService.deleteResolveReason(data?.id).then((response) => {
        this.getResolvedReason();
        this.appMainService.isHideSpinner('isDeleteResolvedUnresolved');
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Resolved data updated successfully...' });
      },
      (error) => {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: error.error?.Message == null
                  ? "Error Occured, try again later"
                  : error.error?.Message,
          });
        this.appMainService.isHideSpinner('isDeleteResolvedUnresolved');

      });
    }
    else {
      this.caseConfigService.deleteUnResolveReason(data?.id).then((response) => {
        this.getUnresolvedReason();
        this.appMainService.isHideSpinner('isDeleteResolvedUnresolved');
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Unresolved data updated successfully...' });
      },
      (error) => {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: error.error?.Message == null
                  ? "Error Occured, try again later"
                  : error.error?.Message,
          });
        this.appMainService.isHideSpinner('isDeleteResolvedUnresolved');

      });
    }
  }

  confirm(data) {
    this.confirmationService.confirm({
        message: "Are you sure that you want to proceed?",
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        rejectLabel: "Cancel",
        accept: () => {
            data.isDefault = !data.isDefault;
        },
    });
  }
}
